"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _v = _interopRequireDefault(require("uuid/v4"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var SESSION_KEY = 'sticky-session-token';
var MULE_STICKY_HEADER_KEY = 'X-SessionID';
var _sessionToken = null;

var StickySessionService = /*#__PURE__*/function () {
  function StickySessionService() {
    _classCallCheck(this, StickySessionService);
  }

  _createClass(StickySessionService, null, [{
    key: "setSessionId",

    /**
     * Creates a random v4 GUID from uuid and sets it in local
     * storage for re-use
     * @returns {string} The session ID for the sticky session
     */
    value: function setSessionId() {
      var token = (0, _v.default)();
      localStorage.setItem(SESSION_KEY, token);
      return token;
    }
    /**
     * Checks whether the session token is stored in memory and if
     * not (depending on localStorage existing) it will either grab it
     * from local storage or create a new one, then set it in memory
     *
     * @returns {string} The session ID for the sticky session
     */

  }, {
    key: "getSessionId",
    value: function getSessionId() {
      if (!_sessionToken) {
        _sessionToken = localStorage ? localStorage.getItem(SESSION_KEY) || this.setSessionId() : this.setSessionId();
      }

      return _sessionToken;
    }
  }, {
    key: "sessionKey",

    /**
     * @returns {string} The key constant for local storage value
     */
    get: function get() {
      return SESSION_KEY;
    }
    /**
     * @returns {string} The key constant for GW Sticky Session
     */

  }, {
    key: "sessionHeaderKey",
    get: function get() {
      return MULE_STICKY_HEADER_KEY;
    }
  }]);

  return StickySessionService;
}();

exports.default = StickySessionService;
//# sourceMappingURL=StickySessionService.js.map